import { fileObject } from "@boark/shared/types/file-object";

import { useGetFiles } from "../queries/get-files";
import { boardMeetingContentFilePath } from "../services/board-meeting";
import { useLocale } from "../stores/locale";
import { EmbeddedFileList } from "./embedded-file-list";
import { FileUpload } from "./file-upload";

// Attachments of a content. Hidden entirely when read only and empty.
export function BoardMeetingContentFiles({
  meetingId,
  contentId,
  readOnly,
}: {
  meetingId: string;
  contentId: string;
  readOnly: boolean;
}) {
  const t = useLocale((state) => state.locale);
  const path = boardMeetingContentFilePath(meetingId, contentId);
  const { data: objects, invalidate } = useGetFiles(path);

  const files = (objects ?? []).filter(
    (
      object,
    ): object is fileObject & {
      type: "file";
      size: number;
      lastModified: Date;
    } => object.type === "file",
  );

  if (readOnly && files.length === 0) {
    return null;
  }

  return (
    <div className="border border-gray-200 rounded-xs bg-white">
      <div className="flex flex-wrap items-center justify-between gap-2 p-2">
        <p className="text-sm font-medium text-gray-700 m-0">
          {t.boardMeeting.attachments}
        </p>
        {!readOnly && (
          <FileUpload path={path} onUpload={() => void invalidate()} />
        )}
      </div>
      <EmbeddedFileList
        files={files}
        path={path}
        readOnly={readOnly}
        onChanged={() => void invalidate()}
      />
    </div>
  );
}
